import type { PublicSlotKey } from '#packages/apilib';
import type { MigrationsManagerApi } from './migrationsManagerApi';

export const MigrationsManagerApiKey: PublicSlotKey<MigrationsManagerApi> = {
  name: 'MigrationsManagerApi',
  public: true,
};
